import { render, staticRenderFns } from "./EstadoDeudaForm.vue?vue&type=template&id=2047c27f&scoped=true"
import script from "./EstadoDeudaForm.vue?vue&type=script&lang=js"
export * from "./EstadoDeudaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2047c27f",
  null
  
)

export default component.exports